import React, { FC } from 'react';
import s from './artistCard.module.scss';
import { ArtistAvatar } from '@components/UIKit/ArtistAvatar/ArtistAvatar';
import { SocialManagerView } from '@specs/views';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import cn from 'classnames';
type ArtistCardProps = {
  data: SocialManagerView.publicProfile;
};
export const ArtistCard: FC<ArtistCardProps> = ({
  data
}) => {
  const {
    shortid
  } = data;
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  return <div className={s.artistCard} data-sentry-component="ArtistCard" data-sentry-source-file="ArtistCard.tsx">
            <div className={s.artistCard__avatar}>
                {!!shortid && <ArtistAvatar shortId={shortid} srcSet={[{
        height: 200,
        width: 200,
        minMedia: 0
      }]} />}
            </div>

            <div className={s.artistCard__info}>
                <b className={cn(s.artistCard__name, '_ellipsis')}>
                    {shortid}
                </b>
                <span className={s.artistCard__description}>
                    Artist
                </span>
            </div>


            <Button id='go_to_artist_artist_card_button' onClick={async () => {
      await router.push({
        pathname: LinksEnum.USER,
        query: {
          slug: shortid
        }
      });
    }} size='medium' color='Black' data-sentry-element="Button" data-sentry-source-file="ArtistCard.tsx">
                {tr({
        id: 'btn.go.to.author'
      })}
            </Button>
        </div>;
};